import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import InitialPageComponent from '../InitialPageComponent/InitialPageComponent';
import LoginPageComponent from '../LoginPageComponent/LoginPageComponent';
import SignUpPageComponent from '../SignUpPageComponent/SignUpPageComponent';
import SuccessPageComponent from '../SuccessPageComponent/SuccessPageComponent';
import InvalidLinkPageComponent from '../InvalidLinkPageComponent/InvalidLinkPageComponent';
import ResetPasswordPageComponent from '../ResetPasswordPageComponent/ResetPasswordPageComponent';
import PasswordResetRequestPageComponent from '../PasswordResetRequestPageComponent/PasswordResetRequestPageComponent';
import SocialLoginPageComponent from '../SocialLoginPageComponent/SocialLoginPageComponent';
import TermsAndConditionsPageComponent from '../TermsAndConditionsPageComponent/TermsAndConditionsPageComponent';
import ChangePasswordPageComponent from '../ChangePasswordPageComponent/ChangePasswordPageComponent';
import OwnerLoginPageComponent from '../OwnerLoginPageComponent/OwnerLoginPageComponent';
import SecurityCheckPageComponent from '../SecurityCheckPageCheckComponent/SecurityCheckPageComponent';
import ChooseContactTypePageComponent from '../ChooseContactTypePageComponent/ChooseContactTypePageComponent';
import ChoosePhonePageComponent from '../ChoosePhonePageComponent/ChoosePhonePageComponent';
import VerifyCodePageComponent from '../VerifyCodePageComponent/VerifyCodePageComponent';
import AccountBlockedPageComponent from '../AccountBlockedPageComponent/AccountBlockedPageComponent';
import authAccountTypes from '../../enums/AuthAccountTypes';
import './MainComponent.less';
import Modal from '@homeaway/react-modal';
import classNames from 'classnames';
import {TrackingContext} from '@homeaway/react-event-tracking';
import ClientLogger from '../../util/clientLogger';
import aamClient from '../../util/aamClient';
import {loadConfig} from '../../util/dynamic.load';
import RiskComponent from '@homeaway/react-risk-component';
import * as lingua from '../../i18n/lingua.message';
import profileClient from '../../util/profileClient';

ClientLogger.initialize({
    errorRoute: '/auth/ui/logs/errors',
    clientLogRoute: '/auth/ui/logs/cl'
});

const DisplayPage = ({displayPage, oauthStateValue, ...props}) => {
    function getSignUpContent(signUpProps) {
        signUpProps.authStatus = authAccountTypes.SIGNUP;
        return <SignUpPageComponent {...signUpProps}/>;
    }

    return (
        <div>
            {{
                LOGIN_UMS: <LoginPageComponent {...props}/>,
                LOGIN_GOOGLE: <SocialLoginPageComponent {...props}/>,
                LOGIN_FACEBOOK: <SocialLoginPageComponent {...props}/>,
                LOGIN_EXPEDIA: <SocialLoginPageComponent {...props}/>,
                SIGNUP: getSignUpContent(props),
                TermsAndConditions: <TermsAndConditionsPageComponent {...props}/>,
                success: <SuccessPageComponent {...props}/>,
                passwordchange: <ChangePasswordPageComponent {...props}/>,
                passwordreset: <ResetPasswordPageComponent {...props}/>,
                invalidLink: <InvalidLinkPageComponent {...props}/>,
                postTandC: oauthStateValue ? <SocialLoginPageComponent {...props}/> : getSignUpContent(props),
                ownerlogin: <OwnerLoginPageComponent {...props}/>,
                checkSecurity: <SecurityCheckPageComponent {...props}/>,
                chooseContactType: <ChooseContactTypePageComponent {...props} />,
                choosePhone: <ChoosePhonePageComponent {...props} />,
                verifyCode: <VerifyCodePageComponent {...props} />,
                passwordresetrequest: <PasswordResetRequestPageComponent {...props} />,
                accountblocked: <AccountBlockedPageComponent {...props} />,
                initial: <InitialPageComponent {...props}/>
            }[displayPage]}
        </div>
    );
};

class MainComponent extends Component {
    static get propTypes() {
        return {
            actionLocation: PropTypes.string,
            locale: PropTypes.string.isRequired,
            site: PropTypes.string.isRequired,
            siteName: PropTypes.string.isRequired,
            service: PropTypes.string.isRequired,
            modalMode: PropTypes.bool,
            handleCloseModal: PropTypes.func,
            handleLoginSuccess: PropTypes.func,
            // The flag to disable the social login when used in the multi-user-traveler app
            multiUserEnabled: PropTypes.bool,
            expediaIconDisplayed: PropTypes.bool,
            serverConfigRendering: PropTypes.bool,
            ticketId: PropTypes.string,
            landingPage: PropTypes.string,
            marketingOptOut: PropTypes.bool,
            isOwnerLogin: PropTypes.bool,
            isLegacy: PropTypes.bool

        };
    }

    static get defaultProps() {
        return {
            actionLocation: '-1',
            locale: 'en_US_VRBO',
            site: 'vrbo',
            siteName: 'Vrbo',
            service: 'misconfigured',
            modalMode: false,
            handleCloseModal: () => {},
            handleLoginSuccess: () => {},
            multiUserEnabled: false,
            expediaIconDisplayed: false,
            configContext: 'base',
            serverConfigRendering: false,
            ticketId: '',
            landingPage: 'initial',
            marketingOptOut: null,
            mfaState: null,
            isOwnerLogin: false,
            isLegacy: false
        };
    }

    constructor(props) {
        super(props);
        let landingPage = this.props.ticketId !== '' ? 'passwordchange' : this.props.landingPage;
        if (landingPage === '') {
            landingPage = 'initial';
        }
        this.state = {
            service: this.props.service,
            modalOpened: true,
            currentPage: landingPage,
            lingua,
            firstName: '',
            emailAddress: '',
            authAccountType: [],
            closeButton: true,
            passwordType: '',
            isWaiting: false,
            authJson: {},
            oauth: null,
            token: null,
            authStatus: null,
            expediaConfigRequired: props.expediaIconDisplayed !== true,
            expediaIconDisplayed: props.expediaIconDisplayed,
            ticketId: this.props.ticketId,
            successContext: this.props.isLegacy === true ? 'legacy' : landingPage,
            marketingOptOut: this.props.marketingOptOut,
            devices: null,
            isOwnerLogin: landingPage === 'ownerlogin',
            mfaState: null,
            contactType: '',
            phoneList: [],
            phoneNumber: '',
            isLegacy: this.props.isLegacy,
            challengeTicket: null,
            linguaOverride: {},
            linguaOverrideRequired: true
        };

        // Bind to the correct context
        this.onClose = this.onClose.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.updatePage = this.updatePage.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.setFirstName = this.setFirstName.bind(this);
        this.performInitialBulkUpdate = this.performInitialBulkUpdate.bind(this);
        this.setAuthAccountType = this.setAuthAccountType.bind(this);
        this.clickBack = this.clickBack.bind(this);
        this.showHidePassword = this.showHidePassword.bind(this);
        this.getMainContent = this.getMainContent.bind(this);
        this.getClassName = this.getClassName.bind(this);
        this.enableLoading = this.enableLoading.bind(this);
        this.disableLoading = this.disableLoading.bind(this);
        this.performBulkPageUpdate = this.performBulkPageUpdate.bind(this);
        this.setAuthJson = this.setAuthJson.bind(this);
        this.loginRefreshSuccess = this.loginRefreshSuccess.bind(this);
        this.checkStatus = this.checkStatus.bind(this);
        this.loadExpediaConfig = this.loadExpediaConfig.bind(this);
        this.handleDevices = this.handleDevices.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.setContactType = this.setContactType.bind(this);
    }

    componentDidMount() {
        lingua.load(this.props.locale).then(() => {
            this.setState({linguaLoaded: true});
        }).catch((e) => {
            ClientLogger.logError(`Unable to load lingua keys for locale ${this.props.locale}. Error=${e}`);
            throw new Error(`Unable to load lingua keys for locale ${this.props.locale}. Error=${e}`);
        });

        if (this.props.configContext !== 'base' || this.state.expediaConfigRequired) {
            this.loadExpediaConfig();
        }

        if (this.props.modalMode) {
            this.context.trigger('generic.modal', {modalaction: 'open', modalname: 'lex'});
        }
    }

    loadExpediaConfig() {
        loadConfig(this.props.locale, this.props.configContext).then((config) => {
            let expediaIconDisplayed = this.props.expediaIconDisplayed === true ? this.props.expediaIconDisplayed : config.expediaIconDisplayed === true;
            let linguaOverride = config.dynamicMessages;
            this.setState({expediaIconDisplayed, expediaConfigRequired: false, linguaOverride, linguaOverrideRequired: false});
        });
    }

    onModalClose() {
        this.context.trigger('generic.modal', {modalaction: 'close', modalname: 'lex'});
        this.props.handleCloseModal();
    }

    loginRefreshSuccess(json) {
        this.context.trigger('login.refresh', {
            loginsource: 'lex',
            logintype: 'ums',
            publicuuid: json.publicUuid
        });
        this.setAuthJson(json);
        if (this.state.isOwnerLogin) {
            this.mfaShouldChallenge();
        } else {
            this.onClose();
        }
    }

    checkStatus(response) {
        if (response.status === 200) {
            response.json().then((json) => {
                this.loginRefreshSuccess(json);
            }, (err) => {
                ClientLogger.logError(`error occurred on recreate session error=${err}`);
            });
        }
    }

    attemptLoginRefresh = () => {
        aamClient.refreshLogin().then(this.checkStatus);
    }

    enableLoading() {
        this.setState({isWaiting: true});
    }

    disableLoading() {
        this.setState({isWaiting: false});
    }

    setAuthJson(json) {
        this.setState({authJson: json});
        if (this.state.currentPage === 'ownerlogin') {
            profileClient.getFirstName().then(this.setFirstName);
        }
    }

    mfaShouldChallenge = () => {
        this.setState({currentPage: 'checkSecurity'});
    }

    startChallengeProcess = (challengeTicket) => {
        this.setState({challengeTicket, currentPage: 'chooseContactType'});
    }

    onClose() {
        if (this.props.modalMode) {
            this.setState(
                {modalOpened: false},
                () => this.invokeHandleLoginSuccess()
            );
        } else {
            this.invokeHandleLoginSuccess();
        }
    }

    invokeHandleLoginSuccess = () => {
        // User is authenticated if authJson is not an empty object
        // so, let the consuming  application know that there was a
        // successful login and send them the json response.
        if (Object.keys(this.state.authJson).length > 0) {
            this.props.handleLoginSuccess(this.state.authJson);
        } else if (this.state.ticketId !== '' || this.props.landingPage !== 'initial') { // this is for redirecting password rest & confirm page!
            this.props.handleLoginSuccess(null);
        }
    };

    performInitialBulkUpdate(pageName, emailAddress, status) {
        let currentList = this.state.authAccountType.slice();
        let newStatuses = status.slice();
        if (currentList.length > 0) {
            currentList.concat(newStatuses);
        } else {
            currentList = newStatuses;
        }
        if (this.state.service === 'misconfigured') { // cannot set href as default prop or tests fail so handling here, mostly for local testing
            this.setState({service: window.location.href});
        }
        this.setState({
            currentPage: pageName,
            closeButton: true,
            passwordType: 'password',
            emailAddress,
            authAccountType: currentList,
            isWaiting: false
        });
    }

    updatePage(pageName) {
        this.setState({
            currentPage: pageName,
            closeButton: true,
            passwordType: 'password'
        });
    }

    performBulkPageUpdate(pageName, emailAddress = null, oauth = null, token = null) {
        this.setState({
            currentPage: pageName,
            emailAddress,
            closeButton: true,
            oauth: [oauth],
            token,
            passwordType: 'password'
        });
    }

    setAuthAccountType(status) {
        let currentList = this.state.authAccountType.slice();
        currentList.push(status);
        this.setState({
            authAccountType: currentList
        });
    }

    setEmail(emailaddress) {
        this.setState({emailAddress: emailaddress});
    }

    setFirstName(firstname) {
        this.setState({firstName: firstname});
    }

    setPhoneNumber(phonenumber) {
        this.setState({phoneNumber: phonenumber});
    }

    setContactType(contacttype) {
        this.setState({contactType: contacttype});
    }

    setMarketingOptOut = (optOut) => {
        this.setState({marketingOptOut: optOut});
    }

    setUserPhones = (phones) => {
        this.setState({phoneList: phones});
    }

    setNumberOfSecurityPhones = (numberOfSecurityPhones) => {
        this.setState({numberOfSecurityPhones});
    }

    clickBack() {
        this.context.trigger('generic.click', {eventcategory: 'lex', eventaction: 'backButton.click'});
        this.setState({
            currentPage: 'initial',
            closeButton: true
        });
    }

    showHidePassword(e) {
        e.preventDefault();
        e.stopPropagation();
        const shouldHide = this.state.passwordType === 'input';
        const eventaction = shouldHide ? 'hide' : 'show';
        this.context.trigger('generic.click', {eventcategory: 'lex', eventaction: `${eventaction}Pwd.click`});
        this.setState({
            passwordType: shouldHide ? 'password' : 'input'
        });
    }

    displayPageProps() {
        return {
            actionLocation: this.props.actionLocation,
            lingua: this.state.lingua,
            firstName: this.state.firstName,
            emailAddress: this.state.emailAddress,
            service: this.state.service,
            authAccountType: this.state.authAccountType,
            onClose: this.onClose,
            setAuthJson: this.setAuthJson,
            performBulkPageUpdate: this.performBulkPageUpdate,
            updatePage: this.updatePage,
            site: this.props.site,
            multiUserEnabled: this.props.multiUserEnabled,
            expediaIconDisplayed: this.state.expediaIconDisplayed,
            marketingOptOut: this.state.marketingOptOut,
            siteName: this.props.siteName,
            passwordType: this.state.passwordType,
            showHidePassword: this.showHidePassword,
            isWaiting: this.state.isWaiting,
            enableLoading: this.enableLoading,
            disableLoading: this.disableLoading,
            setMarketingOptOut: this.setMarketingOptOut,
            locale: this.props.locale,
            currentPage: this.state.currentPage,
            performInitialBulkUpdate: this.performInitialBulkUpdate,
            setAuthAccountType: this.setAuthAccountType,
            authStatus: this.state.authStatus,
            ticketId: this.state.ticketId,
            successContext: this.state.successContext,
            token: this.state.token,
            setEmail: this.setEmail,
            setFirstName: this.setFirstName,
            updateMfaState: this.updateMfaState,
            landingPage: this.props.landingPage,
            phoneList: this.state.phoneList,
            phoneNumber: this.state.phoneNumber,
            numberOfSecurityPhones: this.state.numberOfSecurityPhones,
            setPhoneNumber: this.setPhoneNumber,
            setContactType: this.setContactType,
            contactType: this.state.contactType,
            isLegacy: this.state.isLegacy,
            startChallengeProcess: this.startChallengeProcess,
            challengeTicket: this.state.challengeTicket,
            setPhonesList: this.setUserPhones,
            setNumberOfSecurityPhones: this.setNumberOfSecurityPhones
        };
    }

    getMainContent() {
        const props = this.displayPageProps();
        if (this.props.modalMode) {
            return (
                <Modal
                    id="lex-modal"
                    isOpen={this.state.modalOpened}
                    onClose={this.onClose}
                    onModalClose={this.onModalClose}
                    isInstructional
                    closeButton={this.state.closeButton}
                    header
                >
                    <DisplayPage displayPage={this.state.currentPage} oauthStateValue={this.state.oauth} {...props}/>
                </Modal>
            );
        }
        return <DisplayPage displayPage={this.state.currentPage} oauthStateValue={this.state.oauth} {...props}/>;
    }

    getClassName() {
        const displayPage = this.state.currentPage;
        let modeClassName;
        // CSS will be white content only in these 2 cases, otherwise handle modal & regular page component css separately
        if (displayPage === 'success' || displayPage === 'passwordreset' || displayPage === 'invalidLink') {
            modeClassName = 'WhiteContent';
            modeClassName = this.props.modalMode ? `${modeClassName}` : `${modeClassName} ${modeClassName}--desktop`;
        } else {
            modeClassName = this.props.modalMode ? 'AuthModal' : 'RegularContent';
            // now we add brand
            modeClassName = (this.props.site !== 'vrbo') ? `${modeClassName} ${modeClassName}--gt` : `${modeClassName} ${modeClassName}--gradient`;
            if (displayPage !== 'accountblocked') {
                modeClassName = `${modeClassName} RegularContent--minheight`;
            }
        }

        return classNames(`${modeClassName}`);
    }

    handleDevices(devices) {
        aamClient.setup(devices, this.props.site).then(() => this.setState({devices}));
        if (this.state.currentPage === 'initial' || this.state.currentPage === 'ownerlogin') {
            this.attemptLoginRefresh();
        }
    }


    render() {
        if (!this.state.linguaLoaded) {
            return null;
        }
        if (this.state.expediaConfigRequired && this.props.serverConfigRendering) {
            this.loadExpediaConfig();
        }
        if (!this.state.linguaOverrideRequired) {
            lingua.loadLinguaExperiments(this.state.linguaOverride);
        }
        const modeClassName = this.getClassName();
        const devicesReady = this.state.devices !== null;
        return (
            <div>
                {devicesReady && (
                    <div className={modeClassName}>
                        <ErrorBoundary clientLogger={ClientLogger}>
                            {this.getMainContent()}
                        </ErrorBoundary>
                    </div>
                )}
                <RiskComponent handleDeviceList={this.handleDevices}/>
            </div>
        );
    }
}

MainComponent.contextType = TrackingContext;
export default MainComponent;
